import React, { Component } from 'react';
import instance from "./axios-instance";
import Systems from "./SystemFunction";

const BASE = '/idea-bet.live/theme/1ufaai/';

const sections = [
    {
        title: 'UFAgrand168 โปรโมชั่นความคุ้มค่าที่กล้าแจก',
        body: 'เดิมพัน UFAgrand168 เล่นง่าย เล่นสนุก อัตราจ่ายค่าตอบแทนที่สูง โปรโมชั่นเว็บพนันออนไลน์ ที่พร้อมซับพอร์ตให้กับสมาชิกทุกท่านไม่ว่าจะระดับไหน ลูกค้าเก่าหรือลูกค้าใหม่ ทุนน้อยหรือทุนมาก สามารถได้รับสิทธิประโยชน์ดีๆเหล่านี้ได้เหมือนกัน เนื่องด้วยทำไมเราถึงกล้าแจกโบนัสและเครดิตฟรีอย่างมากมายแบบนี้ นั้นก็เพราะว่าเราคือ เว็บพนันออนไลน์ เว็บตรงขนาดใหญ่ ไม่ผ่านเอเย่นต์มีความมั่นคงทางด้านการเงินเป็นอย่างมาก เราจึงสามารถจัดแคมเปญสุดพิเศษให้แก่ทุกท่านได้อย่างราบรื่น',
    },
    {
        title: 'โปรโมชั่นสุดพิเศษ UFAgrand168 ที่สุดในเอเชีย',
        body: 'เนื่องจากความสนุกแบบจัดเต็มบน UFAgrand168 เว็บตรงของเราแล้ว ยังมีสิ่งดีๆที่เราพร้อมมอบให้ไม่แพ้กันอยู่ นั้นก็คือ โปรโมชั่นแบบจัดเต็มไม่ว่าจะเป็น โปรโมชั่นบาคาร่า, โปรโมชั่นสล็อต, โปรโมชั่นแทงบอล และโปรโมชั่นอื่นๆอีกมากมาย ยกระดับคุณภาพมาตรฐานขึ้นไป ตอกย้ำถึงความน่าเชื่อถือและยังสร้างความมั่นใจให้แก่ทุกท่าน',
    },
    {
        title: 'ร่วมสนุกกับ UFAgrand168 รับโปรโมชั่นได้อย่างจุใจ ทุกวัน',
        body: 'ตอกย้ำการเป็นตัวจริงเรื่อง คาสิโน มาตรฐานแท้ระดับสากลด้วยการแจก โบนัส เครดิตฟรี จัดหนัก จัดเต็มทุกวัน สนุกไปกับเกมที่ชอบแล้วยังสามารถสร้างกำไรได้อย่างง่ายดายด้วยเครดิตฟรี สิ่งเหล่านี้นั้นจะไปช่วยเพิ่มโอกาสการทำเงินให้สูงขึ้นไป ไม่แน่จริงเราไม่กล้าให้อย่างแน่นอน ไม่พลาดทุกการเคลื่อนไหวสามารถติดตามความพิเศษเหล่านี้ได้ที่ UFAgrand168',
    },
    {
        title: 'แทงบอล โปรโมชั่น จัดเต็มด้วยโบนัสมากมาย มีแต่คุ้ม ที่ UFAgrand168',
        body: 'UFAgrand168 ศูนย์รวมความสนุก เว็บพนันที่น่าเชื่อถือได้ อีกทั้งยังมีโปรโมชั่น โบนัสเครดิตฟรี และโบนัสฝากเงินในรูปแบบต่างๆอีกมากมาย คุณสามารถพบกับโปรโมชั่นดีๆได้ตลอด เพราะเรานั้นจัดเต็มให้กับนักเดิมพันทั้งหลาย ไม่ว่าจะเป็นสมาชิกใหม่หรือสมาชิกเก่า มีโปรโมชั่นมากมายหลากหลายเกม คัดสรรโปรโมชั่นที่น่าสนใจ เหมาะกับผู้เล่นทุกรูปแบบ สนุกได้แบบไร้ขีดจำกัด',
    },
];

class PromotionsPage extends Component {
    constructor(props) {
        super(props);
        this.state = { prolistx: [] };
    }

    componentDidMount() {
        instance.post("/api/v1/getpromotion", { System: Systems })
            .then(res => {
                if (res.data.status === 200) {
                    this.setState({ prolistx: res.data.message });
                }
            }).catch(() => {});
    }

    handleClick = (e, no) => {
        e.preventDefault();
        const token = localStorage.getItem('auth_token');
        if (!token) {
            window.location.href = this.props.webnamex ? this.props.webnamex + '/signin' : '/signin';
            return;
        }
        if (this.props.checkurl) this.props.checkurl(e, '/promotion');
    }

    render() {
        const { prolistx } = this.state;
        return (
            <div className="x-promotion-content-class-wrapper x-default-bg-center" style={{ paddingTop: '72px', minHeight: '100vh' }}>
                <link rel="stylesheet" href={BASE + 'style.css'} />

                {/* Title */}
                <div className="-x-headline-title text-center" style={{ padding: '40px 16px 16px' }}>
                    <h1 className="-title" style={{ color: '#EFD0A0', fontSize: '24px', fontWeight: '700' }}>
                        โปรโมชั่น UFAgrand168 จัดเต็มทุกความต้องการ
                    </h1>
                </div>

                {/* Promotion grid */}
                <div className="container">
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '12px', padding: '8px 0 24px' }}>
                        {prolistx.map((p, i) => (
                            <a key={i} href="#0" className="-link-wrapper" onClick={e => this.handleClick(e, p.no)}>
                                <img
                                    className="img-fluid -cover"
                                    src={p.linkpicture}
                                    alt={p.proname}
                                    style={{ width: '100%', borderRadius: '10px', display: 'block' }}
                                />
                            </a>
                        ))}
                    </div>

                    {/* Warning + intro */}
                    <p className="-warning-message" style={{ color: '#aaa', fontSize: '13px', textAlign: 'center', marginBottom: '24px' }}>
                        ⚠️ หากโปรโมชั่นแสดงน้อยกว่า 5 รายการ กรุณาติดต่อ แอดมินเพื่อตรวจสอบสิทธิ์ของคุณทันที
                    </p>

                    {/* SEO sections */}
                    {sections.map((s, i) => (
                        <div key={i} className="-content-section" style={{ border: '1px solid #b8962e', borderRadius: '12px', padding: '22px', marginBottom: '16px', background: 'rgba(0,0,0,0.3)' }}>
                            <h2 style={{ color: '#EFD0A0', fontSize: '18px', fontWeight: '700', marginBottom: '10px' }}>{s.title}</h2>
                            <p style={{ color: '#ccc', lineHeight: '1.8', fontSize: '14px', margin: 0 }}>{s.body}</p>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default PromotionsPage;
